import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';

import { TextFieldComponent } from './text-field.component';
import { AuthService } from '../auth/auth.service';
import { User } from '../users/user.model';

@Component({
  selector: 'app-sender-field-component',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class SenderFieldComponent extends TextFieldComponent {

  pattern: string = "^.*@.*.$";
  defaultValue: string = this.authService.currentUser.email;

  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    private authService: AuthService) { super(cd, overlay); }

  loadDefaultValue() {
    super.loadDefaultValue();
    if (this.defaultValue != null) {
      this.defaultValue = this.defaultValue.toLowerCase();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/sender-field.component.ts